
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"33","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M36 16.5C36 25.06 28.164 32 18.5 32a19.237 19.237 0 01-8.274-1.839L1 32l2.712-7.208C1.996 22.394 1 19.55 1 16.5 1 7.94 8.836 1 18.5 1S36 7.94 36 16.5z","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"9","cy":"16","r":"2"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"18","cy":"16","r":"2"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"27","cy":"16","r":"2"}})])])
          )
        }
      }
    